import React from 'react';
import { useEvent } from '../../pages/events/event/EventProvider';
import { useMint } from '../../pages/events/event/mint/MintNftProvider';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { obfuscateEmail } from '../../utils';
import NftPreview from '../nft/NftPreview';
import './NftPreview.scss';
import Stats from './Stats';

const CoinShiftNftPreview = () => {
  const [{ nftProfile, campaign, event, token }] = useEvent();
  const [{ user }] = useGlobalState();
  const [{ steps, step }] = useMint();
  return (
    <div className='coinshift_nftpreview'>
      {nftProfile?.properties?.Level?.details?.name && (
        <div className='level_container'>
          <p>Current Level</p>
          <h1>{nftProfile?.properties?.Level?.details?.name}</h1>
        </div>
      )}

      <div className='nft_container'>
        <NftPreview className='eventNftPreview' src={nftProfile?.animation_url} template={campaign?.template} />
      </div>
      {nftProfile && user ? (
        <>
          <h1 className='ellipse'>
            {nftProfile?.name} #{token?.tokenId}
          </h1>
          {user?.coinshiftEmail && <p>Coinshift Email - {obfuscateEmail(user?.coinshiftEmail)}</p>}

          <Stats />
        </>
      ) : (
        <>
          <h1> {event?.overview?.title || 'Mint Your NFT To Continue'}</h1>
          <p>
            {event?.overview?.text ||
              'Helu ser! Welcome to the campaign. You need to first mint this mNFT to verify the actions below. mNFTs are data storage vaults that keep storing all the claims of your completed actions.'}
          </p>
          <footer>{steps?.[step]}</footer>
        </>
      )}
    </div>
  );
};

export default CoinShiftNftPreview;
